import React, { Component } from 'react';
import MenuPage from './menu';
import { States } from '../redux/type';
import { ReduxConnect } from '../decorators/redux-connect.decorator';
import '../resources/css/public.css';
import { MenuDish, TurnInfo } from '../constants/type.constant';
import { MinimizeCondiment } from '../modules/cart/type';
import { createHashHistory } from 'history';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import { EventEmitter } from 'events';
import _ from 'lodash';
import HomePageIcon from '../assets/home.png';
import { getCacheField } from '../tools/get-cache-field';
import callWaiterIcon from '../assets/callWaiter.png';
import CallWaiter from './call-waiter';
import ClearIcon from '@material-ui/icons/Clear';
import i18n from '../i18n';
import { GMapGetcurrentLocation } from '../constants/tool-googlemap';
import { DefaultRequest } from '../requests/default.request';
import Store from '../redux/store';
import { WebsocketClient } from '../websocket/module';
let time: NodeJS.Timeout;
@ReduxConnect((defaultState: States, ownProps: Props) => {
    return {
        // 底部导航栏模式
        foodBarMode: defaultState.foodBarMode,
        // 审核状态
        approvalStatus: defaultState.approvalStatus,
        // 倒计时
        resendOrderSecond: defaultState.resendOrderSecond,
        // 订单信息
        orderTab: defaultState.orderTab
    };
})
class LiteMain extends Component<Props, State> {
    [x: string]: any;
    public messengerModule: MessengerModule;
    public distributionIdEmitter!: EventEmitter;
    //缓存上一次tap的时间
    public iLastTouch: number | null = null;
    // show item_name1 or item_name2
    public isShowName1 = true;
    public count = 0;
    constructor(props: Props) {
        super(props);
        this.state = {
            // 加入菜品时的提示状态
            addedTips: false,
            // 勾选提示框是否显示
            isTipsChecked: false,
            // 当前加入到购物车的 item_name
            dishesName: '',
            // 所有顾客的购物车
            cartData: [],
            // 已点数量
            turnCount: 0,
            // 是否开启自主点餐模式
            autonomous: {
                status: true
            },
            // 轮次规则限制是否开启
            globalLimitEnable: true,
            // 轮次规则
            turnInfo: getCacheField('turnInfo'),
            // 开桌审核状态
            isApproved: false,
            // 新手引导显示状态2
            guidehideCardStatus: false,
            // 显示页面
            showCall: false,
            // 禁止点餐（不在餐厅区域）
            disabledOrderBtn: false
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    };
    // *********************
    // 生命周期
    // *********************
    public async UNSAFE_componentWillMount() {
        WebsocketClient.addListener('MESSENGER', this.showMessenger);
    }

    public async componentDidMount() {
        let settingInfo = await DefaultRequest.getSettingInfo();
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'settingInfo',
            value: settingInfo
        });
        // BMap获取当前位置
        const res = await GMapGetcurrentLocation();
        this.setState({ disabledOrderBtn: !!res })
        // $ 防止页面后退
        window.history.pushState(null, '', document.URL);
        window.addEventListener('popstate', function () {
            window.history.pushState(null, '', document.URL);
        });
    }

    public async componentWillUnmount() {
        // $ alwyas unsubscribe in un mount function
        WebsocketClient.removeListener('MESSENGER', this.showMessenger);
        this.setState = (state, callback) => { return; };
        clearInterval(time)
    }


    // *********************
    // 方法区
    // *********************
    /**
     * showMessenger
     */
    public showMessenger = (data: { message: string, level: string }) => {
        try {
            this.messengerModule.say({
                message: data.message,
                level: data.level || "Warning",
            });
        } catch (error) { }
    }
    public getSettingInfoValue(str: string) {
        const SETTING = getCacheField('settingInfo');
        return _.find(SETTING, ['name', str]);
    }

    // *********************
    // 方法区
    // *********************

    /**
     * update local state by object
     * @param val
     */
    public updateLocalState = (val: any) => {
        this.setState(val);
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { approvalStatus, resendOrderSecond, orderTab } = this.props;
        const { showCall, disabledOrderBtn } = this.state;
        return (
            <div className='overall-center main-page' style={{ width: '100%', position: 'fixed', overflow: 'hidden' }}>
                {/* 不在餐厅区域显示蒙层 */}
                {disabledOrderBtn &&
                    <div className='not-in-the-area-mask-box'>
                        <div className='not-in-the-area-mask-box-content'>
                            {i18n.t('general_text_You_are_not_in_the_restaurant_area_unable_to_order')}
                        </div>
                    </div>
                }
                {/* 主题内容 */}
                <div className='overall-center'>
                    {
                        <MenuPage
                            liteMode={true}
                            customer={orderTab.customer}
                            resendOrderSecond={resendOrderSecond}
                            approvalStatus={approvalStatus}
                            updateLocalState={this.updateLocalState}
                        />
                    }
                    {
                        <div className='drawer' style={{
                            transform: showCall ? 'translateY(30px)' : 'translateY(100%)'
                        }}>
                            <div className='titlebar'>
                                <ClearIcon onClick={() => { this.setState({ showCall: false }) }} />
                                <div className='title'>{i18n.t('service_page_text_call_waiter')}</div>
                            </div>
                            <CallWaiter lite={true} />
                        </div>
                    }
                </div>
                {/* 回到首屏页 */}
                <div className='fixedIcon-home' onClick={() => {
                    createHashHistory().push({ pathname: '/LiteHome' });
                }}>
                    <img src={HomePageIcon} alt="主页" width="24" />
                </div>
                <div className='fixedIcon-home' style={{ bottom: 60 }} onClick={() => {
                    this.setState({ showCall: true })
                }}>
                    <img src={callWaiterIcon} alt="service_page_text_call_waiter" width="24" />
                </div>
            </div >
        );
    }

}

export default withSnackbar(LiteMain)

// *********************
// Types
// *********************

type State = {
    addedTips: boolean;
    isTipsChecked: boolean;
    dishesName: string;
    cartData: Array<{
        _origin: MenuDish
        count: number;
        price: number;
        totalPrice: number;
        // excess
        excessCount: number;
        excessPrice: number;
        excessTotalPrice: number;
        // condiment
        condiments: Array<MinimizeCondiment>;
        condimentsTotalPrice: number;
        // for view fields
        excessPriceAndCondimentsPriceForView: string;
    }>
    // 已点数量
    turnCount: number
    // 自主点餐是否开启
    autonomous: {
        status: boolean
    }
    // 轮次规则限制是否开启
    globalLimitEnable: boolean,
    turnInfo: TurnInfo
    // 开桌审核状态
    isApproved: boolean;
    // 新手引导显示状态2
    guidehideCardStatus: boolean;
    // 显示页面
    showCall: boolean;
    // 禁止点餐（不在餐厅区域）
    disabledOrderBtn: boolean;
}

type Props = {
    showCall: 'menuPage' |
    'homePage' |
    'shoppingCartPage' |
    'orderHistory' |
    'adPage' |
    'callWaiter';
    // 底部导航栏模式
    foodBarMode: 'MULTIPLE' | 'SINGLE',
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED',
    // 倒计时
    resendOrderSecond: number,
    // 订单信息
    orderTab: {
        // 开台人数
        person: number;
        // 订单Id
        orderId: number;
        // 菜单信息
        menuList: {
            // id
            main_group_id: number,
            // name
            main_group_name: string,
        };
        // 扫码id
        customer: string;
    }
} & WithSnackbarProps
